import axios from "axios";

const getIP = () => {
    return axios.get('https://api.ipify.org?format=json');
}

export default getIP;